import { Component, Input } from '@angular/core';

import { RouteLinkAction } from '../../../../types/route-link-action';

@Component({
    selector: 'lui-layout-basic',
    templateUrl: './layout-basic.component.html',
    styleUrls: ['./layout-basic.component.scss'],
    standalone: false
})
export class LayoutBasicComponent {
  @Input() showCookies!: boolean;

  // #TODO temporary placed here - move to a seperate service with provider potentially
  @Input() links: RouteLinkAction[] = [
    {
      type: 'link',
      label: 'Privacy notice',
      href: 'https://global.lockton.com/eu/en',
      target: '_blank',
    },
    {
      type: 'link',
      label: 'Cookies notice',
      href: 'https://global.lockton.com/eu/en',
      target: '_blank',
    },
    {
      type: 'link',
      label: 'Terms of use',
      href: 'https://global.lockton.com/eu/en',
      target: '_blank',
    },
    {
      type: 'link',
      label: 'Lockton global',
      href: 'https://global.lockton.com/eu/en',
      target: '_blank',
    },
  ];
}
